import { Injectable } from '@angular/core';
import { WidgetStructureObject } from '../../api/interfaces';
import { CheckBoxCustomization } from '../../components/new-elements/CheckBox/checkbox-edit';
import { ComboBoxCustomization } from '../../components/new-elements/ComboBox/combobox-edit';
import { DatePickerCustomization } from '../../components/new-elements/DatePicker/datepicker-edit';
import { FileDialogCustomization } from '../../components/new-elements/FileDialog/filedialog-edit';
import { MultiRadioButtonCustomization } from '../../components/new-elements/MultiRadioButton/multi-radiobutton-edit';
import {
  defaultMultiplierOption,
  MultiplierRadioButtonCustomization,
} from '../../components/new-elements/MultiplierRadioButton/multiplier-answer';
import { NumericUpDownCustomization } from '../../components/new-elements/NumericUpDown/numericupdown-edit';
import { RadioButtonCustomization } from '../../components/new-elements/RadioButton/radiobutton-edit';
import { StaticTextCustomization } from '../../components/new-elements/StaticText/staticitext-edit';
import { TextBoxCustomization } from '../../components/new-elements/TextBox/textbox-edit';

interface WidgetStrctureList<T = unknown> extends WidgetStructureObject<T> {
  label: string;
  icon: string;
}

@Injectable()
export class ElementService {
  widgetList: WidgetStrctureList[] = [
    {
      _type: 'widget',
      _mappedType: 'TextBox',
      customization: {
        description: 'Descrizione',
        placeHolder:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam in dui mauris. Nulla facilisi.',
        showIfRule: '',
        weight: 1,
      },
      label: 'Text Input',
      icon: 'heroicons_outline:bars-3-bottom-left',
    } as WidgetStrctureList<TextBoxCustomization>,
    {
      _type: 'widget',
      _mappedType: 'NumericUpDown',
      customization: {
        description: 'Descrizione',
        showIfRule: '',
      },
      label: 'Numeric Input',
      icon: 'heroicons_outline:calculator',
    } as WidgetStrctureList<NumericUpDownCustomization>,
    {
      _type: 'widget',
      _mappedType: 'DatePicker',
      customization: {
        description: 'Descrizione',
        topology: 0,
        showIfRule: '',
      },
      label: 'Date Input',
      icon: 'heroicons_outline:calendar-days',
    } as WidgetStrctureList<DatePickerCustomization>,
    {
      _type: 'widget',
      _mappedType: 'ComboBox',
      customization: {
        description: 'Descrizione',
        options: [
          {
            label: 'Opzione 1',
            value: 'option_1',
            valueEqualsDescription: false,
            weight: 2,
          },
          {
            label: 'Opzione 2',
            value: 'option_2',
            valueEqualsDescription: false,
            weight: 1,
          },
          {
            label: 'Opzione 3',
            value: 'option_3',
            valueEqualsDescription: false,
            weight: 0,
          },
        ],
        showIfRule: '',
        defaultValue: 'option_1',
      },
      label: 'Drop-down',
      icon: 'heroicons_outline:queue-list',
    } as WidgetStrctureList<ComboBoxCustomization>,
    {
      _type: 'widget',
      _mappedType: 'CheckBox',
      customization: {
        description: 'Descrizione',
        showIfRule: '',
        weight: 1,
      },
      label: 'Check Box',
      icon: 'heroicons_outline:check',
    } as WidgetStrctureList<CheckBoxCustomization>,
    {
      _type: 'widget',
      _mappedType: 'RadioButton',
      customization: {
        description: 'Descrizione',
        options: [
          {
            label: 'Si',
            value: 'yes',
            valueEqualsDescription: false,
            weight: 1,
            type: 'string',
          },
          {
            label: 'No',
            value: 'no',
            valueEqualsDescription: false,
            weight: 0,
            type: 'string',
          },
        ],
        showIfRule: '',
      },
      label: 'Radio Button',
      icon: 'heroicons_outline:list-bullet',
    } as WidgetStrctureList<RadioButtonCustomization>,
    {
      _type: 'widget',
      _mappedType: 'MultiRadioButton',
      customization: {
        description: 'Descrizione',
        cap: 1,
        groups: [
          {
            key: 'group_1',
            label: 'Gruppo 1',
            defaultValue: '',
            options: [
              {
                label: 'Si',
                value: 'yes',
                valueEqualsDescription: false,
                weight: 1,
                type: 'string',
              },
              {
                label: 'No',
                value: 'no',
                valueEqualsDescription: false,
                weight: 0,
                type: 'string',
              },
            ],
          },
        ],
        showIfRule: '',
        autocompleteRule: '',
      },
      label: 'Multi Radio Button',
      icon: 'heroicons_outline:list-bullet',
    } as WidgetStrctureList<MultiRadioButtonCustomization>,
    {
      _type: 'widget',
      _mappedType: 'MultiplierRadioButton',
      customization: {
        description: 'Descrizione',
        decimal: false,
        options: [
          defaultMultiplierOption(),
          {
            key: 'option_1',
            label: 'Opzione 1',
            multiplier: 1,
            min: 0,
            max: 10,
          },
        ],
        required: false,
        showIfRule: '',
        autocompleteRule: '',
      },
      label: 'Radio con moltiplicatore',
      icon: 'heroicons_outline:scale',
    } as WidgetStrctureList<MultiplierRadioButtonCustomization>,
    {
      _type: 'widget',
      _mappedType: 'FileDialog',
      customization: {
        description: 'Carica un file',
        showIfRule: '',
      },
      label: 'File Input',
      icon: 'heroicons_outline:paper-clip',
    } as WidgetStrctureList<FileDialogCustomization>,
    {
      _type: 'widget',
      _mappedType: 'StaticText',
      customization: {
        description:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam in dui mauris. Nulla facilisi.',
        showIfRule: '',
      },
      label: 'Static Text',
      icon: 'heroicons_outline:bars-3',
    } as WidgetStrctureList<StaticTextCustomization>,
  ];

  dropList: string[] = [];
}
